import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

import { TextEditor } from '@/components/TextEditor'
import useSearchParams from '@/hooks/useSearchParams'
import { useLoadMeasuresByFormAndClientId } from '@/queries/measures/useLoadMeasuresByFormAndClientId'
import { useUpdateMeasuresQuestionsByFormId } from '@/queries/measures/useUpdateMeasuresQuestionsByFormId'

export const InstructionsMeasures = () => {
  const { clientId } = useParams<{ clientId?: string }>()
  const searchParams = useSearchParams()
  const formId = searchParams.get('formId') || ''
  const questionId = searchParams.get('question') || ''

  const { data: measureData, isLoading: isLoadingMeasure } =
    useLoadMeasuresByFormAndClientId(formId || '', clientId || '')

  const { updateMeasuresQuestionsByFormId } =
    useUpdateMeasuresQuestionsByFormId({
      formId,
      clientId,
      questionId,
    })

  const onBlur = async (text: string) => {
    try {
      await updateMeasuresQuestionsByFormId({
        formId,
        data: { instructions: text },
      })
    } catch (error) {
      toast.error('Error trying to save Instructions')
    }
  }

  if (isLoadingMeasure) return null
  return (
    <div className="mb-16 flex w-full flex-col gap-1">
      <h2 className="font-medium text-gray-700">Instructions:</h2>
      <TextEditor
        className="bg-white"
        minHeight={150}
        onBlur={onBlur}
        tools={[
          'bold',
          'italic',
          'strike',
          'underline',
          'bulletList',
          'orderedList',
          'link',
          'image',
          'left',
          'center',
          'right',
          'table',
          'size',
          'color',
          'highlight',
        ]}
        value={measureData?.instructions || undefined}
      />
    </div>
  )
}
